import { ca } from '@cian/analytics';

import { TNewbuildingPurchaseGiftPromoSource } from './NewbuildingPurchaseGiftPromoContext';

// TODO: HBC-1800 имена событий уточнить по спецификации аналитики (отдельная задача эпика)
const CATEGORY = 'NewbuildingPurchaseGift';

function track(action: string, label: string, extra?: Record<string, unknown>) {
  ca('eventSite', {
    name: 'oldevent',
    category: CATEGORY,
    action,
    label,
    useLastProducts: true,
    ...(extra && { page: { extra } }),
  });
}

export function trackEntryPointShow(source: TNewbuildingPurchaseGiftPromoSource) {
  track('show_sopr', 'entry_point', { source });
}

export function trackEntryPointClick(source: TNewbuildingPurchaseGiftPromoSource) {
  track('click', 'entry_point', { source });
}

export function trackModalShow(source: TNewbuildingPurchaseGiftPromoSource) {
  track('show_sopr', 'modal', { source });
}

export function trackModalClose(reason: string) {
  track('close', 'modal', { reason });
}

export function trackModalConfirm() {
  track('click', 'modal_confirm');
}

export function trackCopyEmail(result: string) {
  track('click', 'modal_copy_email', { result });
}

export function trackTermsClick() {
  track('click', 'modal_terms');
}

export function trackStepView(step: number) {
  track('show_sopr', 'modal_step', { step });
}
